// Dev-only structured logger. In production builds, warnings/info are no-ops.
const isDev = process.env.NODE_ENV === "development";

export const logger = {
  warn: (...args) => {
    if (isDev) console.warn("[bp]", ...args);
  },
  info: (...args) => {
    if (isDev) console.info("[bp]", ...args);
  },
  // Always log actual errors — these should surface to Sentry-style pipelines
  error: (...args) => {
    console.error("[bp]", ...args);
  },
};
